import React from 'react';
import PropTypes from "prop-types";

import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import { BootstrapDialog } from "components/Elements/Dialog/common"
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { InvitationEditor } from './Editor';
import InvitationRedemption from './Redeem';


const InvitationRedemptionDialog = ({ open, close, onRedeemed }) => {

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md')); //size at which dialog goes full screen

    return <BootstrapDialog
        aria-labelledby="customized-dialog-title"
        open={open}
        fullScreen={fullScreen}
        fullWidth={true}
        maxWidth="xl">
        <DialogTitle sx={{ m: 0, p: 2 }} style={{ backgroundColor: theme.palette.secondary.main }}>
            <SoftBox>
                <SoftTypography variant="h6" color="white" textTransform="capitalize" opacity={0.7}>
                    Redeem Invitation
                </SoftTypography>
            </SoftBox>
        </DialogTitle>
        <DialogContent dividers>
            <SoftBox mt={3}>
                <InvitationRedemption onRedeemed={onRedeemed}/>
            </SoftBox>
        </DialogContent>
    </BootstrapDialog>;
}

InvitationRedemptionDialog.propTypes = {
};

const InvitationEditorDialog = ({ open, close, cardroom, union, club, invitation }) => {

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md')); //size at which dialog goes full screen

    return <BootstrapDialog
        aria-labelledby="customized-dialog-title"
        open={open}
        fullScreen={fullScreen}
        fullWidth={true}
        maxWidth="xl">
        <DialogTitle sx={{ m: 0, p: 2 }} style={{ backgroundColor: theme.palette.secondary.main }}>
            <SoftBox>
                <SoftTypography variant="h6" color="white" textTransform="capitalize" opacity={0.7}>
                    Invitation
                </SoftTypography>
            </SoftBox>
        </DialogTitle>
        <DialogContent dividers>
            <SoftBox mt={3}>
                <InvitationEditor cardroom={cardroom} union={union} club={club} invitation={invitation} onClose={close} dense={false} />
            </SoftBox>
        </DialogContent>
    </BootstrapDialog>;
}

InvitationEditorDialog.defaultProps = {

};

InvitationEditorDialog.propTypes = {
    cardroom: PropTypes.object.isRequired,
    union: PropTypes.object.isRequired,

};

export { InvitationEditorDialog, InvitationRedemptionDialog };
